import { Notification } from '../models/Notification';

const defaultState: Notification = {
  variant: 'default',
  message: null,
};

export const snackbarNotifier = {
  state: defaultState,
  reducers: {
    notify: (_currentState: Notification, nextState: Notification) => nextState,
    reset: () => ({ variant: 'default', message: null }),
  },
};
